package pwgs.ui.components

import visage.core.Components
import visage.dom.tag

fun  Components.BigStatNumber(title: String, value: String, color: String) {
    tag("div") {
        style.apply {
            display = "block"
            width = "100%"
        }

        tag("div") {
            style.apply {
                display = "block"
                textAlign = "center"
                fontSize = "14px"
                this.color = color
            }
            +title
        }

        tag("div") {
            style.apply {
                display = "block"
                textAlign = "center"
                fontSize = "32px"
                fontWeight = "bold"
                this.color = color
            }
            +value
        }
    }
}